import { Packaging } from 'src/gqlReactTypings.generated.d';
import { titleCase } from 'src/shared/utils/DateTimeUtilities';

export const AVAILABLE_PACKAGING_OPTIONS = [Packaging.Unknown, Packaging.Compostable];
export const PACKAGING_OPTIONS: Record<Packaging, string> = {
  [Packaging.Compostable]: titleCase(Packaging.Compostable),
  [Packaging.Recylable]: titleCase(Packaging.Recylable),
  [Packaging.Reusable]: titleCase(Packaging.Reusable),
  [Packaging.Unknown]: 'Regular',
};

export const PACKAGING_TEXT = {
  title: 'Packaging',
};
